import moment from 'moment'
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { LOGO_COPEC_BASE_64 } from "@/constants/common";

export default {
    // Categorias de documentos
    document_category_quotes: 0,
    document_category_other: 1,
    document_category_oc: 2,

    // Categorias de Texto de documentos
    document_category_quotes_text: "Cotizacion",
    document_category_maverick_purchase_text: "Maverick",
    document_category_other_text: "Otros",
    document_category_oc_text: "OC",

    // Supplier Email Validation
    supplier_uploaded_by_purchase_user: 'ABASTECIMIENTO',
    supplier_uploaded_by_user: 'NO ABASTECIMIENTO',

    //Estatus de los servicios de una solicitud de servicio
    service_statuses: {
        in_quotation: "En Cotizacion",
        quotation_ready: "Cotizacion Lista",
        in_review: "En Revision",
        pending_validation: "Pendiente de Validacion",
        quotation_in_validation: "Maverick Validacion",
        purchase_validation: "Pendiente de Validacion por Abastecimiento",
        purchase_validation_variant: "Pendiente de Revision por Abastecimiento",
        user_validation: "Pendiente de Validacion por Usuario",
        user_validation_variant: "Pendiente de Revision por Usuario",
        pending_user: "Pendiente de Usuario",
        pending: "Pendiente de Aprobacion",
        approved: "Aprobada",
        cancelled: "Cancelada",
        rejected: "Rechazada",
        rejected_variant: "Rechazado",
    },
    // Monto de servicio para solicitar mas documentos de cotizaciones
    service_amount_to_request_more_quotes_files: 20000000,

    //Monto Maximo de servicio para que solo sea cotizado por compras
    service_amount_to_request_only_quotes_from_supply: 100000000,

    //Monto Maximo de servicio para pasar por licitación
    service_amount_to_request_bidding: 200000000,

    // Numero de documentos para una solicitud de servicio que sobrepasa el monto de servicio
    min_number_of_documents_for_service_over_service_amount: 3,
    
    // Numero minimo de documentos para una solicitud de servicio
    min_number_of_documents_for_service: 1,

    //Código de cuenta de activos
    asset_account_code: 'AFI-000001',

    // Tipos de cambio
    coin_types: [
      {
        value: 'CLP',
        text: 'CLP',
        currency_symbol: '$'
      },
      {
        value: 'USD',
        text: 'USD',
        currency_symbol: '$'
      },
      {
        value: 'EUR',
        text: 'EUR',
        currency_symbol: '€'
      },
      {
        value: 'UF',
        text: 'UF',
        currency_symbol: 'UF'
      },
    ],

    //Valor de Comprador sin Asignar
    unassigned_purchase_user: 'unassigned',

    getCurrencySymbol: function(coin) {
      return this.coin_types.find(item => item.value == coin).currency_symbol || '-';
    },
    
    //Obtener el listado de estatus de las solicitudes de servicio
    service_statuses_list: function() {
      return [
        this.service_statuses.in_quotation,
        this.service_statuses.pending,
        this.service_statuses.purchase_validation,
        this.service_statuses.purchase_validation_variant,
        this.service_statuses.user_validation,
        this.service_statuses.user_validation_variant,
        this.service_statuses.approved,
        this.service_statuses.cancelled,
        this.service_statuses.rejected_variant,
      ]
    } ,
    getStatusCorrection: function(status) {
      if(status == this.service_statuses.purchase_validation){
        return this.service_statuses.purchase_validation_variant.replace("Revision", "Revisión") + " (Maverick)"
      }
      if(status == this.service_statuses.user_validation){
        return this.service_statuses.user_validation_variant.replace("Revision", "Revisión") + " (Maverick)"
      }
      return status
        .replace("Cotizacion", "Cotización")
        .replace("Aprobacion", "Aprobación")
        .replace("Revision", "Revisión")
        .replace("Validacion", "Validación");
    },
    getDocumentCategory: function(category, isMaverickRequest = false) {
      switch(category){
        case 'Cotizacion':
          return this.document_category_quotes
        case 'OC':
          return this.document_category_oc
        default:
          return this.document_category_other 
      }
    },
    getTypeDocumentFromFile(document, isMaverickRequest = false){
      switch(document.category){
        case this.document_category_quotes:
          return 'Cotizacion'
        case this.document_category_oc:
          return 'OC'
        default:
          return 'Otros'
      }
    },
    // Verificar si el servicio es un activo
    isServiceIsAnAsset: function(service){
      return service.code == this.asset_account_code
    },
    //Calcular el monto total de servicio que es la cantidad por el monto de servicio
    calculateTotalService: function(service){
      let serviceAmount =  service.price ? Number(service.price.replaceAll(".", "")) : 0
      return serviceAmount * service.quantity;
    },
    // Validar si el servicio tiene una cotización con un precio y proveedor definido y una carta de aprobación maverick
    // && service.documents.find(document => document.category == this.document_category_maverick_purchase);
    ifServiceHasQuotedWithPriceAndSupplierAndHaveMaverickLetter: function (service){
      return service.documents.find(document => document.category == this.document_category_quotes && document.price && document.supplier_rut) 
    },
    // Obtener el color de la etapa de un servicio
    getStatusColor: function(status){
        switch(status){
          case this.service_statuses.in_quotation:
            return 'warning'
          case this.service_statuses.in_review:
            return 'cyan'  
          case this.service_statuses.quotation_ready:
            return 'success'
          case this.service_statuses.pending_validation:
            return 'info'
          case this.service_statuses.purchase_validation:
            return 'deep-orange darken-2'
          case this.service_statuses.purchase_validation_variant:
            return 'deep-orange darken-2'
          case this.service_statuses.quotation_in_validation:
            return 'grey'
          case this.service_statuses.user_validation:
            return 'teal darken-2'
          case this.service_statuses.user_validation_variant:
            return 'teal darken-2'
          case this.service_statuses.pending:
            return 'purple'
          case this.service_statuses.cancelled:
            return 'red darken-2'
          case this.service_statuses.rejected:
            return 'red darken-2'
          case this.service_statuses.rejected_variant:
            return 'red darken-2'
          default:
            return 'primary'
        }
      },
    // Validar si el servicio no tiene un comentario adjunto
    ifServiceHasNoComment: function (service){
      return service.comment == null || service.comment == '';
    },
    /*VALIDACIONES COTIZACIONES*/
    // Validar si el servicio posee una cotización adjunta y no tiene precio o proveedor definido
    ifServiceHasQuotedWithNoPriceOrSupplier: function (service){
      return service.documents.find(document => document.category == this.document_category_quotes && (!document.price || !document.supplier_rut));
    },

    //Obtener el numero de cotizaciones necesarias para el servicio
    getNumberOfQuotesNeccesarys: function(service){
      //. Si el servicio tiene al menos una cotización con el valor unique supplier, se necesita 1 cotizacion
      if(
        service.documents.find(document =>
          document.category == this.document_category_quotes &&
          (document.unique_supplier || document.unique_supplier_with_contract)
        )
      )
        return 1
      //2. Si el servicio tiene una cotización con precio mayor a la cantidad máxima de 1.000.000 y no poseen el valor unique supplier, se necesitan 3 cotizaciones
      else if(
        service.documents.find(document => {
          let priceDocument = document.price ? document.coin !== this.coin_types[0].value && document.amount ? Number(document.amount.replaceAll(".", "").replaceAll(",", "")) : Number(document.price.replaceAll(".", "").replaceAll(",", "")) : 0
          return document.category == this.document_category_quotes && priceDocument >= this.service_amount_to_request_more_quotes_files
        })
      )
        return 3
      else 
        return 1
    },

    
    //Obtener el numero de cotizaciones necesarias para el servicio cuando ya es una OC en BD
    getNumberOfQuotesNeccesarysOCCreated: function(service){
      //. Si el servicio tiene al menos una cotización con el valor unique supplier, se necesita 1 cotizacion
      if(
        service.documents.find(document =>
          document.document_type == this.document_category_quotes_text &&
          (document.unique_supplier || document.unique_supplier_with_contract)
        )
      ){
        return 1
      }
      //2. Si el servicio tiene una cotización con precio mayor a la cantidad máxima de 1.000.000 y no poseen el valor unique supplier, se necesitan 3 cotizaciones
      else if(
        service.documents.find(document => {
          let priceDocument = document.price ? document.coin !== this.coin_types[0].value ? document.amount ? Number(document.amount.replaceAll(".", "").replaceAll(",", "")) : 0 : document.price : 0
          return document.document_type == this.document_category_quotes_text && priceDocument >= this.service_amount_to_request_more_quotes_files
        })
      ){
        return 3
      }
      else {
        return 1
      }
    },
    /*FIN VALIDACIONES COTIZACIONES*/
    // Validar que el servicio tenga al menos una cotización (Para compras)
    ifServiceHasQuotedFromTeamPurchase: function (service){
      return service.documents.find(
        document => document.document_type == this.document_category_quotes_text &&
        document.created_by !== service.created_by
      );
    },
    // Validar que todas las cotizaciones tengan un precio y proveedor definido (Para compras)
    ifServiceHasQuotedWithNoPriceOrSupplierFromTeamPurchase: function (service){
      return service.documents.find(
        document => document.document_type == this.document_category_quotes_text &&
        (!document.price || !document.supplier) &&
        document.created_by !== service.created_by
      );
    },
    // Obtener las cotizaciones del servicio
    getServiceQuotes: function(service){
      return service.documents.filter(document => document.category == this.document_category_quotes)
    },
    // Obtener las cotizaciones del servicio posterior a la creacion del servicio
    getServiceQuotesPostService: function(service){
      return service.documents.filter(document => document.document_type == this.document_category_quotes_text)
    },
    // Validar si hay mas de una cotizacion y no hay ninguna seleccionada
    ifServiceHasMoreThanOneQuoteAndNoOneIsSelected: function(service){
      return this.getServiceQuotes(service).length > 1 && service.documents.filter(document => document.category == this.document_category_quotes && document.selected).length == 0
    },  
    // Validar si el documento es una cotización
    isDocumentAQuote: function(document){
      return document.category == this.document_category_quotes
    },
    // Validar si el servicio necesita una cotización
    getIfserviceNeedQuotation: function(service){
      if(
        this.getServiceQuotes(service).length < this.min_number_of_documents_for_service_over_service_amount
        && service.documents.some(document => document.price && Number(document.price.replaceAll(".", "").replaceAll(",", ".")) >= this.service_amount_to_request_more_quotes_files)
      ){
        return true
      }
      if(!this.getServiceQuotes(service).length){
        return true
      }

      return false
    },
    // Validar si la solicitud tiene 14 dias de diferecia o mas entre la fecha de cancelacion y la fecha actual
    isRequestCancelationHas14DaysDiffFromToday: function(request){
      let requestDate = moment(request.cancellation_date).format('YYYY-MM-DD')
      let todayDate = moment()
      return todayDate.diff(requestDate, 'days') >= 14
    },
    //Validar que la solicitud no tenga cotizaciones con un proveedor invalido
    ifRequestHasQuotesWithInvalidSupplier: function(request){
      let self = this
      return request.items.some(function(item) {
        return self.ifServiceHasQuotesWithInvalidSupplier(item)
      })
    },
    //Validar que un servicio no tenga cotizaciones con un proveedor invalido
    ifServiceHasQuotesWithInvalidSupplier: function(service){
      let self = this
      return service.documents.some(document => self.ifDocumentHasQuotesWithInvalidSupplier(document))
    },
    //Validar que un documento no tenga cotizaciones con un proveedor invalido
    ifDocumentHasQuotesWithInvalidSupplier: function(document){
      return !document.valid_supplier
    },
    //Validar si hay alguna cotización seleccionada con un proveedor invalido y cargada por un usuario
    ifRequestHasQuotesUploadedByUserWithInvalidSupplier: function(request){
      let self = this
      return request.items.some(function(item) {
        return item.documents.find(document => {
          return document.supplier_email == self.supplier_uploaded_by_user && document.selected && !document.valid_supplier
        })
      })
    },
    //Validar si la solicitud de aprobación tiene un documento de cotización con un proveedor único
    ifRequestApproveIsUniqueSupplier: function(service_request){
      return service_request.items.some(function(item) {
        let documentsFromQuotation = []
        if(item.quotations.length){
          documentsFromQuotation = item.quotations.map(document => {
            return {
              ...document.quotation_document,
              quotation_id: document.quotation.id,
              selected: document.selected,
              unique_supplier: document.unique_supplier,
            }
          })
        }
        return [...documentsFromQuotation, ...item.documents].find(document => {
          return document.unique_supplier
        }) || false
      })
    },
    //Validar si la solicitud de aprobación tiene un documento de cotización con proveedor único y contrato
    ifRequestApproveIsUniqueSupplierWithContract: function (service_request){
      return service_request.items.some(function(item) {
        let documentsFromQuotation = []
        if(item.quotations.length){
          documentsFromQuotation = item.quotations.map(document => {
            return {
              ...document.quotation_document,
              quotation_id: document.quotation.id,
              selected: document.selected,
              unique_supplier_with_contract: document.unique_supplier_with_contract,
            }
          })
        }
        return [...documentsFromQuotation, ...item.documents].find(document => {
          return document.unique_supplier_with_contract
        }) || false
      })
    },
    //Validar si el servicio tiene un documento de cotización con un proveedor único
    ifServiceRequestIsUniqueSupplier: function(service){
      return service.documents.find(document => {
        return document.unique_supplier
      }) || false
    },
    //Validar si el servicio posee un documento de tipo OC
    ifServiceHasOC: function(service){
      return service.documents.find(document => document.document_type == this.document_category_oc_text)
    },
    //Validar si todos los servicios de una solicitud poseen un documento de tipo OC
    ifAllServicesHaveOC: function(request){
      return request.items.every(item => item.documents.find(document => document.document_type == this.document_category_oc_text))
    },
    //Verificar si algun documento tiene un coin diferente a CLP
    verifyAnyDocumentHasCoinDiferentThanCLP: function(services){
      return services.some(service => service.documents.find(document => document.coin && document.coin !== this.coin_types[0].value))
    },
    //Verificar si hay mas de una moneda en los documentos seleccionados de los servicios
    verifyIfHaveMoreThanOneCoinInDocuments: function(services) {
      const selectedCurrencies = services.map(service => {
          let allDocuments = [...service.documents, ...service.quotations.map(quotation => ({
            ...quotation.quotation_document,
            quotation_id: quotation.quotation.id,
            selected: quotation.selected,
            unique_supplier: quotation.unique_supplier,
            tax_exempt: quotation.quotation_document.tax_exempt
          }))]
          const selectedDocument = allDocuments.find(doc => doc.selected);
          return selectedDocument ? selectedDocument.coin : null;
      });

      // Filter out null values and check if there are different currencies
      const uniqueCurrencies = new Set(selectedCurrencies.filter(coin => coin !== null));
      
      return uniqueCurrencies.size > 1;
    },
    //Calcular el monto total de todos los servicios en base al documento seleccionado teniendo en cuenta la cantidad del servicio
    calculateTotalAmountFromDocuments: function(services) {
      const selectedPrices = services.map(service => {
          let allDocuments = [...service.documents, ...service.quotations.map(quotation => ({
            ...quotation.quotation_document,
            quotation_id: quotation.quotation.id,
            selected: quotation.selected,
            unique_supplier: quotation.unique_supplier,
            tax_exempt: quotation.quotation_document.tax_exempt
          }))]
          const selectedDocument = allDocuments.find(doc => doc.selected);
          return selectedDocument ? selectedDocument.price * service.quantity : null;
      });
      return {
          total: selectedPrices.reduce((total, price) => total + price, 0), 
          coin: services[0].documents.find(doc => doc.selected) ? 
            services[0].documents.find(doc => doc.selected).coin : 
            services[0].quotations.find(quotation => quotation.selected) ?
            services[0].quotations.find(quotation => quotation.selected)?.quotation_document.coin : '-'}
    },
    //Obtener la moneda del documento seleccionado del servicio
    getSelectedDocumentCoin(service) {
      const selectedDocument = service.documents.find(doc => doc.selected);
      return selectedDocument ? selectedDocument.coin : '-';  
    },
    //Obtener el monto del documento seleccionado del servicio
    getSelectedDocumentPrice(service) {
      const selectedDocument = service.documents.find(doc => doc.selected);
      return selectedDocument ? selectedDocument.price : '-';  
    },
  //Validar si el servicio posee un documento de tipo OC
  ifServiceHasOC: function(service){
    return service && service.documents && service.documents.find(document => document.document_type == this.document_category_oc_text)
  },
  //Validar si todos los servicios de una solicitud poseen un documento de tipo OC
  ifAllServicesHaveOC: function(request){
    return request.items.every(item => item.documents.find(document => document.document_type == this.document_category_oc_text))
  },
  //Generar PDF de OC
  generateOcPDF: function(dataOc, nameFile){
     const doc = new jsPDF({
      orientation: "p", // "p" para vertical, "l" para horizontal
      unit: "mm", // Unidades en milímetros
      format: "letter" // Tamaño carta
     });

      doc.addImage(LOGO_COPEC_BASE_64, 'PNG', 10, 15, 45, 25); // (x, y, width, height)

      doc.setFontSize(10);
      doc.setFont("helvetica", "bold");   
      doc.text(dataOc['Comprador'], 60, 20, {});
      doc.text("Dirección: ", 60, 26);
      doc.setFont("helvetica", "normal");
      doc.text(dataOc['Comprador Direccion'], 80, 26);
      doc.setFont("helvetica", "bold");   
      doc.text("Teléfono: ", 60, 32);
      doc.setFont("helvetica", "normal");
      doc.text(dataOc['Comprador Telefono'], 80, 32);
      doc.setFont("helvetica", "bold");
      doc.text("Correo:", 60, 38);
      doc.setFont("helvetica", "normal");
      doc.text(dataOc['Comprador Correo'], 80, 38);
      doc.setFont("helvetica", "bold");
      doc.text("Giro: ", 60, 44);
      doc.setFont("helvetica", "normal");
      doc.text(dataOc['Comprador Giro'], 80, 44);
      doc.setFont("helvetica", "bold");
      doc.text(dataOc['Proyecto'] ? 'Proyecto:' : "Centro de Costo: ", 60, 50);
      doc.setFont("helvetica", "normal");
      doc.text(dataOc['Proyecto'] ? dataOc['Proyecto'] : dataOc['Centro de Costo'], dataOc['Proyecto'] ? 80 : 90, 50);

      doc.setFont("helvetica", "bold");
      doc.text("Número OC: ", 150, 20);
      doc.setFont("helvetica", "normal");
      doc.text(dataOc['Numero'].toString(), 175, 20);
      doc.setFont("helvetica", "bold");
      doc.text("Fecha Doc: ", 150, 26);
      doc.setFont("helvetica", "normal");
      doc.text(moment(dataOc['Fecha Documento']).format("DD-MM-YYYY"), 175, 26);
      doc.setFont("helvetica", "bold");
      doc.text("RUT: ", 150, 32);
      doc.setFont("helvetica", "normal");
      doc.text(dataOc['RUT Comprador'], 175, 32);


      // ENCABEZADO GENERAL
      doc.setFontSize(12);
      doc.setFont("helvetica", "bold");
      doc.text("Orden de Compra", 85, 65);
      doc.setFont("helvetica", "normal");

      doc.setDrawColor(0, 0, 0); // Color negro
      doc.setLineWidth(0.5); // Grosor de la línea
      doc.line(70, 67, 135, 67); // Coordenadas (x1, y1, x2, y2)


      // INFORMACIÓN DEL PROVEEDOR (ESTILO COLUMNA DOBLE)
      autoTable(doc, {
        startY: 75,
        head: [],
        body: [
          ["Código Proveedor:", dataOc['Proveedor Codigo'], "RUT:", dataOc['Proveedor RUT']],
          ["Nombre Proveedor:", dataOc['Nombre Proveedor'], "Persona de Contacto:", dataOc['Persona de Contacto'] ? dataOc['Persona de Contacto'] : "-"],
          ["Dirección Proveedor:", dataOc['Direccion Proveedor'] ? dataOc['Direccion Proveedor'] : "-", "Condición de Pago:", dataOc['Condicion de Pago'] ? dataOc['Condicion de Pago'] : "-"]
        ],
        styles: {
          halign: "left",
          fillColor: [255, 255, 255], // Fondo blanco
          textColor: [0, 0, 0], // Texto negro,
          lineWidth: 0, // Elimina bordes internos
          fontSize: 9,
          cellPadding: 2,
        },
        headStyles: {
          fillColor: [255, 255, 255], // Fondo blanco en encabezado
          textColor: [0, 0, 0], // Texto negro en encabezado,
          lineWidth: 0 // Sin bordes internos en encabezado
        },
        tableLineColor: [0, 0, 0], // Borde exterior negro
        tableLineWidth: 0.2, // Grosor del borde exterior
        alternateRowStyles: {
          fillColor: [255, 255, 255] // Fondo blanco en filas alternas
        },
        columnStyles: {
          0: { fontStyle: "bold" },
          2: { fontStyle: "bold" },
        },
      });

      // TABLA DE PRODUCTOS
      autoTable(doc, {
        startY: doc.lastAutoTable.finalY + 10,
        head: [["Código Artículo", "Descripción", "Cantidad", "U.M.", "Precio", "Impuesto", "% Dcto", "Precio Final"]],
        body: 
          dataOc['Materiales'].map(item => [
            item['Codigo'],
            item['Nombre'],
            item['Cantidad'],
            item['Unidad'],
            `${item['Moneda']} ${new Intl.NumberFormat("es-Cl", {
              minimumFractionDigits: 0,
              maximumFractionDigits: 2,
            }).format(item['Precio'])}`,
            item['Impuesto'],
            item['Descuento Porcentaje'],
            `${item['Moneda']} ${ new Intl.NumberFormat("es-Cl", {
              minimumFractionDigits: 0,
              maximumFractionDigits: 2,
            }).format(item['Total'])}`
          ])
        ,
        styles: {
          fontSize: 9,
          fillColor: [255, 255, 255], // Fondo blanco
          textColor: [0, 0, 0], // Texto negro
          lineColor: [0, 0, 0], // Bordes negros
          lineWidth: 0.3 // Grosor del borde
        },
        headStyles: {
            fillColor: [255, 255, 255], // Fondo blanco en encabezado
            textColor: [0, 0, 0], // Texto negro en encabezado
            lineColor: [0, 0, 0], // Bordes negros
            lineWidth: 0.3 // Grosor del borde
        },
        alternateRowStyles: {
            fillColor: [255, 255, 255] // Fondo blanco en filas alternas
        }
      });

      autoTable(doc,{
        startY: doc.lastAutoTable.finalY + 10,
        startX: 150,
        body: [
            ['Neto:', `${dataOc['Moneda']} ${ new Intl.NumberFormat("es-Cl", {
              minimumFractionDigits: 0,
              maximumFractionDigits: 2,
            }).format(dataOc['Total'])}`],
            ['Impuesto:', `${dataOc['Moneda']} ${ new Intl.NumberFormat("es-Cl", {
              minimumFractionDigits: 0,
              maximumFractionDigits: 2,
            }).format(dataOc['IVA'])}`],
            ['Descuento:', `${dataOc['Moneda']} ${ new Intl.NumberFormat("es-Cl", {
              minimumFractionDigits: 0,
              maximumFractionDigits: 2,
            }).format(dataOc['Descuento'])}`],
            ['Pago Total:', `${dataOc['Moneda']} ${ new Intl.NumberFormat("es-Cl", {
              minimumFractionDigits: 0,
              maximumFractionDigits: 2,
            }).format(dataOc['Total con Descuento'])}`]
        ],
        styles: { fillColor: [255, 255, 255], textColor: [0, 0, 0] },
        headStyles: { fillColor: [255, 255, 255], textColor: [0, 0, 0] },
        columnStyles: {
            0: { halign: 'left', fontStyle: 'bold' },
            1: { halign: 'right' }
        },
        tableLineColor: [0, 0, 0], // Borde exterior negro
        tableLineWidth: 0.2, // Grosor del borde
        tableWidth: 60, // Define el ancho de la tabla en milímetros,
        margin: { left: 142 }
      });

      const purchaseStartY = doc.internal.pageSize.height - 25;
                  
      doc.setFontSize(9);

      // Comprador
      doc.setFont("helvetica", "bold");      
      doc.text("Comentario:", 10, purchaseStartY);
      doc.setFont("helvetica", "normal");

      const puchaseUser = `${dataOc['sale_order']}`;

      doc.text(puchaseUser, 36, purchaseStartY, { maxWidth: 100 });

      // Instrucciones de Facturación
      doc.setFont("helvetica", "bold");      
      doc.text("Instrucciones de Facturación:", 10, purchaseStartY + 8);
      doc.setFont("helvetica", "normal");

      doc.text("Para servicios debe incluir como Referencia en el XML del Facturador Electrónico del SII la Orden de Compra (OC) en el Campo (801), Hoja de Entrada de Servicio (HES) en el Campo (802). Para Materiales sólo referenciar OC. Facturas deben enviarse a facturasap@copecflux.cl.", 60, purchaseStartY + 8, { maxWidth: 150 });

      // Convertir el PDF a Blob
      const pdfBlob = doc.output("blob");

      const pdfFile = new File([pdfBlob], `${nameFile}.pdf`, { type: "application/pdf" });

      return pdfFile;
  }
}